import React, { useEffect, createElement } from 'react';
export function FacebookPixel() {
  useEffect(() => {
    try {
      // Initialize Facebook Pixel
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        // Get head element as fallback if no scripts exist
        s = b.getElementsByTagName(e)[0] || b.getElementsByTagName('head')[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      // @ts-ignore
      window.fbq('init', '2149710085802744');
      // @ts-ignore
      window.fbq('track', 'PageView');
      // Add noscript pixel
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=2149710085802744&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
      // Clean up
      return () => {
        if (document.body.contains(noscript)) {
          document.body.removeChild(noscript);
        }
      };
    } catch (error) {
      console.error('Error initializing Facebook Pixel:', error);
    }
  }, []);
  return null;
}